import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

const QUERY = gql`
  query QueryCOAssetsStatus($id: Int!) {
    project(id: $id) {
      id
      assetProcessingStatus
    }
  }
`;

type Variables = BackendQueryProjectArgs;

export const queryCOAssetsStatus = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<BackendProject>(result.data)?.assetProcessingStatus;
};
